import styled from 'styled-components'
import { Button } from 'dsm-react-lib'
import { IconBookmark } from '@tabler/icons-react'
import { useTrackEvent } from '@microsoft/applicationinsights-react-js'
import { appInsights } from '../../_services/AppInsights'
import { EventType } from '../../utility/types'
import { useAppsService } from '../../_services/AppsService'

const NotificationContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: -10px;
  margin-left: -10px;
`

const NotificationChildrens = styled.div`
  margin-left: 10px;
  margin-top: 10px;
`

const NotificationMainChildrens = styled.div`
  margin-left: 10px;
  margin-top: 10px;
`

const ButtonContainer = styled.div`
  display: inline-flex;
  gap: 20px;
`
const CTAButtons = styled(Button)`
  font-size: '12px !important';
  width: ${(props) => props.width}px;
  margin-top: 0rem !important;
  height: 40px !important;
`

const ToastrComponentArcRoles = ({ application, onClose, label, main }) => {
  const trackAddToWorkspace = useTrackEvent(appInsights, EventType.AddToWorkspace)
  const { addApplication } = useAppsService()

  const addToWorkspaceHandler = async (item) => {
    try {
      const response = await addApplication(item)

      if (response && response.data !== true) {
        console.error(`An error occured ${application?.name}`)
      } else {
        trackAddToWorkspace({ appAdd: JSON.stringify(item) })
      }
    } catch (error) {
      console.error(`An error occured ${application?.name}`)
    }
  }

  return (
    <NotificationContainer>
      <NotificationChildrens>
        <b>{label}</b>
      </NotificationChildrens>
      <NotificationChildrens></NotificationChildrens>
      <NotificationMainChildrens>{main}</NotificationMainChildrens>
      <NotificationChildrens></NotificationChildrens>
      <NotificationMainChildrens>
        <ButtonContainer>
          <CTAButtons
            color="primary"
            variant="outline"
            className={`d-flex justify-content-center btn-block px-1 dsm-brand-accent`}
            onClick={() => addToWorkspaceHandler(application)}
            width="90"
            label="Add"
            icon={<IconBookmark size={16} />}></CTAButtons>
          <CTAButtons
            label="I will do it later"
            color="danger"
            variant="outline"
            className={`d-flex justify-content-center btn-block px-1`}
            onClick={onClose}
            width="130"></CTAButtons>
        </ButtonContainer>
      </NotificationMainChildrens>
    </NotificationContainer>
  )
}

export default ToastrComponentArcRoles
